import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=274474a0&scoped=true&"
import script from "./ProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./ProfileEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEdit.vue?vue&type=style&index=0&id=274474a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274474a0",
  null
  
)

export default component.exports